// components
import Button from '@drivesally/sally-ui/lib/components/Button/Button';
import CheckBox from '@drivesally/sally-ui/lib/components/CheckBox/CheckBox';
import Select from '@drivesally/sally-ui/lib/components/Select/Select';

// layout components
import CompactLabel from '../../../layout/components/CompactLabel/CompactLabel';
import FlowScroll from '../../../layout/components/FlowScroll/FlowScroll';
import StepFooter from '../../../layout/components/StepFooter/StepFooter';

// local components
import Controls from './components/Controls';
import Grid from './components/Grid';
import Item from './components/Item';
import Section from './components/Section';

// propTypes
import PropTypes from 'prop-types';

// react
import React, {Fragment} from 'react';

// gas constants
import {CATEGORY_DISPLAY} from '@drivesally/sally-fn/lib/gas/constants/categories.const.gas';

const CATEGORY_OPTIONS = [
  {value: '', label: 'No category'},
  ...Object.entries(CATEGORY_DISPLAY).map(([value, {label}]) => ({
    value,
    label,
  })),
];

// carry_over only ever gets read from an onsite_sitting gas object when it's
// backfilled into a newly-created onboard object - flagging it anywhere else
// would never actually do anything.
const carryOverEligible = (type) => type === 'onsite_sitting';

const BranchGasStep = ({
  Container,
  onBack,
  onChange,
  onChangeCategory,
  onChangeCarryOver,
  onNext,
  sections,
  ...attributes
}) => (
  <Fragment>
    <Container padding="none">
      <FlowScroll>
        {sections.map((section) => (
          <Fragment key={section.type}>
            <CompactLabel>{section.label}</CompactLabel>
            <Grid>
              {section.sections.map((gasSection) => {
                const entry = attributes[section.type].find(
                  ({key}) => key === gasSection.key
                );
                return (
                  <Item key={gasSection.key}>
                    <Section
                      selected={!!entry}
                      onClick={onChange({
                        type: section.type,
                        section: gasSection.key,
                      })}
                    >
                      <i className={`mdi mdi-${gasSection.icon}`} />
                      {gasSection.label}
                    </Section>
                    {!!entry && (
                      <Controls>
                        <Select
                          size="small"
                          notFilterable
                          value={entry.category || ''}
                          onChange={onChangeCategory({
                            type: section.type,
                            section: gasSection.key,
                          })}
                          options={CATEGORY_OPTIONS}
                        >
                          Category
                        </Select>
                        {carryOverEligible(section.type) && (
                          <CheckBox
                            value={entry.carry_over}
                            onChange={onChangeCarryOver({
                              type: section.type,
                              section: gasSection.key,
                            })}
                          >
                            Carry over to Launching
                          </CheckBox>
                        )}
                      </Controls>
                    )}
                  </Item>
                );
              })}
            </Grid>
          </Fragment>
        ))}
      </FlowScroll>
    </Container>
    <Container>
      <StepFooter
        left={
          <Button size="small" theme="grey" onClick={onBack}>
            Back
          </Button>
        }
        right={
          <Button size="small" theme="grey" onClick={onNext}>
            Next
          </Button>
        }
      />
    </Container>
  </Fragment>
);

BranchGasStep.propTypes = {
  Container: PropTypes.any,
  offboard: PropTypes.array,
  onBack: PropTypes.func,
  onboard: PropTypes.array,
  onChange: PropTypes.func,
  onChangeCategory: PropTypes.func,
  onChangeCarryOver: PropTypes.func,
  onNext: PropTypes.func,
  onsite_sitting: PropTypes.array,
  onsite: PropTypes.array,
  sections: PropTypes.array,
};

export default BranchGasStep;
